import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllAreaByLocationId = async (
  organisationID = "",
  id,
  multipleId = []
) => {
  const locationFilter =
    multipleId.length > 0 ? { id: { $in: multipleId } } : { id: { $eq: id } };
  const query = qs.stringify(
    {
      sort: ["id:desc"],
      filters: {
        $and: [
          {
            organisation: {
              id: {
                $eq: organisationID,
              },
            },
          },
          {
            location: locationFilter,
          },
        ],
      },
      populate: [
        "locations",
        "location",
        "mainLocation",
        "users.userProfile.personalPicture",
        "createdByUser",
        "parentLocation",
        "subLocations",
        "teams",
        "customer.logo",
        "vendors",
        "users.role",
        "people",
        "updatedByUser",
        "team",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `areas?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllAreaByLocationIdActive = async (organisationID = "", id) => {
  let locationID;

  if (id[1]) {
    locationID = id;
  } else {
    locationID = id[0];
  }

  let filters = {
    $and: [
      {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
      },
      {
        location: {
          id: {
            $eq: locationID,
          },
        },
      },
    ],
  };
  const query = qs.stringify(
    {
      sort: ["id:desc"],
      filters: filters,
      populate: [
        "locations",
        "location",
        "mainLocation",
        "users.userProfile.personalPicture",
        "createdByUser",
        "parentLocation",
        "subLocations",
        "teams",
        "customer.logo",
        "vendors",
        "users.role",
        "people",
        "updatedByUser",
        "team",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `areas?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;
   
    return the_response;
  } catch (err) {
    
    if (err.response) {
      
    } else if (err.request) {
      
    } else {
      
    }
   
  }
};

export const updateMainLocation = async (id, mainLocation, organisation) => {
  try {
    let params = {
      mainLocation,
      organisation,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "locations/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
   
    return the_response;
  } catch (err) {
    
    if (err.response) {
      
    } else if (err.request) {
      
    } else {
      
    }
   
    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateGeofencingCoords = async (id, geofencingCoords) => {
  try {
    let params = {
      geofencingCoords,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "locations/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
   
    return the_response;
  } catch (err) {
    
    if (err.response) {
      
    } else if (err.request) {
      
    } else {
      
    }
   
  }
};

export const getAllLocations = async (organisationID = "") => {
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
      },
      populate: [
        "geofencingCoords",
        "customFields",
        "mainLocation",
        "users.userProfile.personalPicture",
        "createdByUser",
        "parentLocation",
        "subLocations",
        "teams",
        "customer.logo",
        "vendors",
        "users.role",
        "people",
        "updatedByUser",
        "team",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `locations?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;
    
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllParentLocations = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 25,
  customer = [],
  country = [],
  city = [],
  sort = [],
  role,
  allIds,
  currentUserId
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    customers: {
      id: {
        $in: customer,
      },
    },

    country: {
      $in: country,
    },
    city: {
      $in: city,
    },
  };

  if (searchName === "") {
    assetFilters.isParent = {
      $eq: true,
    };
  }

  if (searchName) {
    assetFilters.$or = [
      {
        name: {
          $containsi: searchName,
        },
      },
      {
        countId: {
          $containsi: searchName,
        },
      },
      {
        countryName: {
          $containsi: searchName,
        },
      },
      {
        cityName: {
          $containsi: searchName,
        },
      },
    ];
  }

  if (role !== "super_admin") {
    assetFilters.id = {
      $in: allIds,
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,

    populate: [
      "geofencingCoords",
      "customFields",
      "mainLocation",
      "users.userProfile.personalPicture",
      "createdByUser",
      "updatedByUser",
      "createdByUser.profileImage",
      "parentLocation",
      "parentLocation.customers",
      "parentLocation.customers.logo",
      "subLocations",
      "teams",
      "customers",
      "customers.logo",
      "vendors",
      "vendors.logo",
      "propertyType",
      "areas",
      "image",

      "users.role",
      "users.profileImage",
      "procedure",
      "subLocations.procedure",
      "subLocations.propertyType",
      "subLocations.customers",
      "subLocations.customers.logo",
      "subLocations.vendors.logo",
      "subLocations.areas",
      "subLocations.image",
      "subLocations.customFields",

      "subLocations.createdByUser",
      "subLocations.createdByUser.profileImage",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `locations?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;
    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };
    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
